const useAlert = () => {
  const debug = process.env.REACT_APP_DEBUG === 'true' ? true : false

  return {
    debug,
  }
}

export default useAlert
